export default `varying vec3 vColor;

void main() {
    vec2 centered = gl_PointCoord - vec2(0.5);
    float dist = dot(centered, centered);

    if (dist > 0.25) {
        discard;
    }

    float alpha = smoothstep(0.25, 0.2, dist);
    gl_FragColor = vec4(vColor, alpha);
}`